import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';
import { ValidatedInput, ValidationGroup } from '@bingads-webui-react/validation-controls';

export class NameEditor extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isValid: true,
    };
  }

  onValidate = (result) => {
    this.setState({
      isValid: result.isValid,
    });
  };

  render() {
    return (
      <div className="image-name-container">
        <ValidationGroup validationProps={{ stopPropagation: true }} >
          <ValidatedInput
            className="image-name-input"
            value={this.props.value}
            onChange={this.props.onChanged}
            validationProps={{
              schema: {
                properties: {
                  Text: {
                    type: 'string',
                    maxLength: 512,
                  },
                },
              },
              field: 'Text',
              i18n: this.props.i18n,
              onValidate: this.onValidate,
            }}
            id="image-name-field"
            ariaLabel={this.props.i18n.getString('ImageExperience_Edit_Image_Name')}
          />
          <Button onClick={this.props.onSave} disabled={!this.state.isValid}>
            {this.props.i18n.getString('Audience_Campaign_Save_Label')}
          </Button>
          <Button onClick={this.props.onCancel}>
            {this.props.i18n.getString('Audience_Campaign_Cancel_Label')}
          </Button>
        </ValidationGroup>
      </div>
    );
  }
}

NameEditor.propTypes = {
  value: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};


NameEditor.defaultProps = {
  value: '',
};
